import React, { ReactNode, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Layout as AntLayout, Menu, Avatar, Dropdown, Grid, Drawer, Button } from 'antd';
import {
  DashboardOutlined, TeamOutlined, FileTextOutlined, CreditCardOutlined,
  BankOutlined, WarningOutlined, SettingOutlined, LogoutOutlined,
  MenuOutlined, UserOutlined,
} from '@ant-design/icons';
import { useAuth } from '../context/AuthContext';
import './Layout.css';

const { Header, Sider, Content } = AntLayout;
const { useBreakpoint } = Grid;

const VOCI = [
  { key: '/',           icon: <DashboardOutlined />,  label: 'Dashboard' },
  { key: '/users',      icon: <TeamOutlined />,       label: 'Utenti' },
  { key: '/posts',      icon: <FileTextOutlined />,   label: 'Post' },
  { key: '/billing',    icon: <CreditCardOutlined />, label: 'Fatturazione' },
  { key: '/accounting', icon: <BankOutlined />,       label: 'Contabilità' },
  { key: '/disputes',   icon: <WarningOutlined />,    label: 'Dispute' },
  { key: '/settings',   icon: <SettingOutlined />,    label: 'Impostazioni' },
];

const TITOLI: Record<string, string> = {
  '/': 'Dashboard', '/users': 'Utenti', '/posts': 'Post', '/billing': 'Fatturazione',
  '/accounting': 'Contabilità', '/disputes': 'Dispute', '/settings': 'Impostazioni',
};

export default function Layout({ children }: { children: ReactNode }) {
  const { user, logout } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const schermo = useBreakpoint();
  const [drawer, setDrawer] = useState(false);

  const compatto = !schermo.lg;

  // /users/12 deve tenere illuminata la voce "Utenti"
  const selezionata = pathname.startsWith('/users') ? '/users' : pathname;
  const titolo = TITOLI[selezionata] || 'Molti Like';

  const menu = (
    <>
      <div className="brand">
        <img src="/logo.png" alt="Molti Like" />
      </div>
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[selezionata]}
        items={VOCI.map(v => ({
          key: v.key,
          icon: v.icon,
          label: <Link to={v.key} onClick={() => setDrawer(false)}>{v.label}</Link>,
        }))}
      />
    </>
  );

  return (
    <AntLayout style={{ minHeight: '100vh' }}>
      {compatto ? (
        <Drawer
          open={drawer}
          onClose={() => setDrawer(false)}
          placement="left"
          width={244}
          closable={false}
          styles={{ body: { padding: 0, background: '#101527' } }}
        >
          {menu}
        </Drawer>
      ) : (
        <Sider width={244} className="sider">{menu}</Sider>
      )}

      <AntLayout>
        <Header className="topbar">
          {compatto && (
            <Button
              type="text"
              icon={<MenuOutlined />}
              onClick={() => setDrawer(true)}
              aria-label="Apri il menu"
            />
          )}
          <h1 className="topbar-title">{titolo}</h1>

          <Dropdown
            trigger={['click']}
            menu={{
              items: [
                { key: 'chi', label: <span className="who">{user?.email}</span>, disabled: true },
                { type: 'divider' as const },
                {
                  key: 'esci', icon: <LogoutOutlined />, label: 'Esci', danger: true,
                  onClick: () => { logout(); navigate('/login'); },
                },
              ],
            }}
          >
            <button className="user-btn" aria-label="Menu utente">
              <Avatar size={31} style={{ background: '#4F72FF' }} icon={<UserOutlined />} />
              {!compatto && <span className="user-label">{user?.name || 'Admin'}</span>}
            </button>
          </Dropdown>
        </Header>

        <Content className="content">{children}</Content>
      </AntLayout>
    </AntLayout>
  );
}
